export enum ListItemIcon {
  account = 'account',
  arrivals = 'arrivals',
  bell = 'bell',
  checkmark = 'checkmark',
  chevron = 'chevron',
  circle = 'circle',
  download = 'download',
  heart = 'heart',
  info = 'info',
  payment = 'payment',
  ribbon = 'ribbon',
  sale = 'sale',
  star = 'star',
  truck = 'truck',
  order = 'order',
  invoice = 'invoice',
  recommendations = 'recommendations',
  faster_checkout = 'faster_checkout'
}

export const LIST_ITEM_ICON_COLOR_VALUES = {
  blue: 'text-EXPONDO-secondary',
  black: 'text-EXPONDO-black',
} as const;

export interface IconicListItemInterface {
  icon?: ListItemIcon;
  iconColor?: ValueOf<typeof LIST_ITEM_ICON_COLOR_VALUES>;
  text: string;
  url?: string;
}
